import { render } from "./DataBoxes.vue?vue&type=template&id=a6734332"
import script from "./DataBoxes.vue?vue&type=script&lang=js"
export * from "./DataBoxes.vue?vue&type=script&lang=js"
script.render = render

export default script